<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner" title="Why Choose Soul Space?" subtitle="Why Choose Soul Space?"></app-page-banner>
        <!-- INNER PAGE BANNER END -->


        <div class="container pt-2 pb-5">
            <div class="row align-items-center">
                <!-- Left Side: Image -->
                <div class="col-lg-6 col-md-12 m-b10">
                    <div class="image-container text-center mt-4 mb-4">
                            <img src="assets/images/thumbnail_silhouette-image-of-many-people-holding-and-puttin-2024-11-25-17-09-57-utc.jpg" alt="Welcome to Soul Space" class="img-fluid rounded-img shadow-img">
                        </div>
                    </div>
                
                    <!-- Right Side: Text Content -->
                    <div class="col-lg-6 col-md-12">
                        <div class="text-content mobcontent" style="position: relative; bottom: 122px;">
                            <div class="separator-line mb-4 mobcontene"></div>
                            <!-- <h5>Why Choose Soul Space</h5> -->
                            <p >
                                <ul class="centered-list">
                                    <li>Personalized Care from experienced professionals.</li>
                                    <li>Age-specific treatment plan.</li>
                                    <li>Perfect blend of modern scientific treatments that are <span style="margin-left: 27px;">clinically proven.</span></li>
                                    <li>Holistic Wellbeing - Mind, Body & Soul.</li>
                                </ul>
                
                            
                        </div>
                    </div>
                </div>
            </div>

    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>